import React from 'react';

import { Typography } from '@rbilabs/universal-components';
import { Platform } from 'react-native';

import SodiumFlag from 'components/product-detail-v2/nutrition-information/sodium-flag';
import { useLocale } from 'state/intl';
import { Region } from 'utils/environment/types';

export const SodiumDisclaimerUS = () => {
  const { region } = useLocale();
  if (region === Region.US) {
    const iconStyles = Platform.select({
      default: 3,
      ios: 12,
    });
    return (
      <Typography variant="copyTwo">
        Warning: <SodiumFlag size="22px" style={{ transform: [{ translateY: iconStyles }] }} />{' '}
        indicates that sodium (salt) content of this item is higher than the total daily recommended
        limit (2,300mg). High Sodium intake can increase blood pressure and risk of heart disease
        and stroke.
      </Typography>
    );
  }
  return null;
};
